import PreviewImg from './PreviewImg'
export default PreviewImg